  (function() {
    'use strict';
    
    const widgetConfigNode = document.getElementById('moxie-floating-call-widget');
    const MOXIE_TEXTS = {
      successTitle: (widgetConfigNode && widgetConfigNode.dataset.successTitle) || '¡Gracias!',
      successMessage: (widgetConfigNode && widgetConfigNode.dataset.successMessage) || 'Hemos recibido tu solicitud correctamente. Te llamaremos pronto.',
      errorTitle: (widgetConfigNode && widgetConfigNode.dataset.errorTitle) || 'Error',
      submittingText: (widgetConfigNode && widgetConfigNode.dataset.submittingText) || 'Enviando...'
    };
    
    function initFloatingButton() {
      // Intentar múltiples veces para asegurar que el DOM esté listo
      const widget = document.getElementById('moxie-floating-call-widget');
      const button = document.getElementById('moxie-floating-call-button');
      const popup = document.getElementById('moxie-floating-call-popup');
      
      if (!widget || !button || !popup) {
        console.warn('Moxie Floating Button: Elementos no encontrados, reintentando...');
        // Reintentar después de un delay
        setTimeout(initFloatingButton, 200);
        return;
      }
      const closeButton = document.getElementById('moxie-floating-call-close');
      const actionButton = document.getElementById('moxie-floating-call-action');

      widget.style.cssText = 'position: fixed !important; z-index: 999999 !important; bottom: 200px !important; right: 20px !important; display: block !important; visibility: visible !important; opacity: 1 !important; pointer-events: auto !important; width: auto !important; height: auto !important; overflow: visible !important;';
      button.style.cssText = 'display: flex !important; visibility: visible !important; opacity: 1 !important; background-color: #00A859 !important; color: white !important; border: none !important; padding: 12px 20px !important; border-radius: 50px !important; cursor: pointer !important;';
      // Solo ocultar el botón flotante si el slot de callback está activo en el popup de ayudas.
      // Si el slot no existe (checkbox desactivado), el botón vive en su posición nativa.
      if (document.querySelector('[data-help-native-slot="callback"]')) {
        button.style.setProperty('display', 'none', 'important');
      } else {
        button.style.removeProperty('display');
      }
      
      // Forzar visibilidad también en los elementos hijos
      const buttonText = button.querySelector('.moxie-floating-call-button__text');
      const buttonIcon = button.querySelector('.moxie-floating-call-button__icon');
      if (buttonText) {
        buttonText.style.cssText = 'display: inline !important; visibility: visible !important; opacity: 1 !important;';
      }
      if (buttonIcon) {
        buttonIcon.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important; width: 20px !important; height: 20px !important;';
      }

      // Crear overlay si no existe
      let overlay = document.querySelector('.moxie-floating-call-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'moxie-floating-call-overlay';
        document.body.appendChild(overlay);
      }

      // Abrir el popup
      function openPopup() {
        popup.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        if (overlay) overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }

      // Referencias a las vistas (declarar antes de closePopup)
      const initialView = document.getElementById('moxie-popup-initial-view');
      const formView = document.getElementById('moxie-popup-form-view');
      const messageView = document.getElementById('moxie-popup-message-view');
      const callForm = document.getElementById('moxie-call-form');
      const formBackButton = document.getElementById('moxie-form-back');
      const formLoading = document.getElementById('moxie-form-loading');
      const messageTitle = document.getElementById('moxie-message-title');
      const messageText = document.getElementById('moxie-message-text');
      const messageIcon = document.getElementById('moxie-message-icon');
      const messageCloseButton = document.getElementById('moxie-message-close');

      // Mostrar el formulario
      function showForm() {
        if (initialView && formView && messageView) {
          initialView.style.display = 'none';
          formView.style.display = 'flex';
          messageView.style.display = 'none';
        }
      }

      // Volver a la vista inicial
      function showInitialView() {
        if (initialView && formView && messageView) {
          formView.style.display = 'none';
          messageView.style.display = 'none';
          initialView.style.display = 'flex';
          // Limpiar el formulario
          if (callForm) {
            callForm.reset();
          }
        }
      }

      // Mostrar mensaje de éxito
      function showSuccessMessage(title, message) {
        if (initialView && formView && messageView && messageTitle && messageText && messageIcon) {
          // Ocultar otras vistas
          initialView.style.display = 'none';
          formView.style.display = 'none';
          
          // Configurar mensaje de éxito
          messageTitle.textContent = title || '¡Gracias!';
          messageText.textContent = message || 'Hemos recibido tu solicitud correctamente.';
          messageIcon.className = 'moxie-message-icon moxie-message-icon--success';
          
          // Mostrar vista de mensaje
          messageView.style.display = 'flex';
        }
      }

      // Mostrar mensaje de error
      function showErrorMessage(title, message) {
        if (initialView && formView && messageView && messageTitle && messageText && messageIcon) {
          // Ocultar otras vistas
          initialView.style.display = 'none';
          formView.style.display = 'none';
          
          // Configurar mensaje de error
          messageTitle.textContent = title || 'Error';
          messageText.textContent = message || 'Hubo un error al procesar tu solicitud.';
          messageIcon.className = 'moxie-message-icon moxie-message-icon--error';
          
          // Mostrar vista de mensaje
          messageView.style.display = 'flex';
        }
      }

      // Cerrar el popup
      function closePopup() {
        showInitialView(); 
        popup.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-expanded', 'false');
        if (overlay) overlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      // Callback opcional a ejecutar cuando el usuario pulsa "Volver" desde el formulario.
      let _onFormBack = null;

      // API pública para abrir este flujo desde otros widgets (popup de ayudas).
      window.MoxieFloatingCallWidget = {
        open: openPopup,
        close: closePopup,
        openForm: function(onBack) {
          _onFormBack = (typeof onBack === 'function') ? onBack : null;
          showForm();   // primero fija la vista del formulario en el DOM
          openPopup();  // luego revela el popup (la transición CSS ya muestra el formulario)
        },
        openInitial: function() {
          _onFormBack = null;
          showInitialView();
          openPopup();
        }
      };

      // Event listeners
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        const isOpen = popup.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          closePopup();
        } else {
          openPopup();
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          closePopup();
        });
      }

      // Cerrar al hacer clic en el overlay
      if (overlay) {
        overlay.addEventListener('click', function(e) {
          e.stopPropagation();
          closePopup();
        });
      }

      // Cerrar al presionar Escape
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
          closePopup();
        }
      });

      // Prevenir que el clic en el popup lo cierre
      popup.addEventListener('click', function(e) {
        e.stopPropagation();
      });


      // Acción del botón "Te llamamos"
      if (actionButton) {
        actionButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          showForm();
        });
      }

      // Botón para volver atrás
      if (formBackButton) {
        formBackButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          if (typeof _onFormBack === 'function') {
            var cb = _onFormBack;
            _onFormBack = null;
            closePopup();
            cb();
          } else {
            showInitialView();
          }
        });
      }

      // Botón para cerrar el mensaje
      if (messageCloseButton) {
        messageCloseButton.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          showInitialView();
          closePopup();
        });
      }

      // Validar formato de teléfono colombiano (10 dígitos)
      function validatePhone(phone) {
        // Remover espacios y caracteres no numéricos
        const cleanPhone = phone.replace(/\D/g, '');
        // Debe tener exactamente 10 dígitos
        return cleanPhone.length === 10 && /^[0-9]{10}$/.test(cleanPhone);
      }

      function setFormLoadingState(isLoading, submitButton, originalText) {
        if (callForm) {
          callForm.setAttribute('aria-busy', isLoading ? 'true' : 'false');
          const controls = callForm.querySelectorAll('input, button');
          controls.forEach(function(control) {
            control.disabled = isLoading;
          });
        }

        if (submitButton) {
          submitButton.textContent = isLoading ? MOXIE_TEXTS.submittingText : originalText;
        }

        if (formLoading) {
          formLoading.classList.toggle('is-active', isLoading);
          formLoading.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
        }
      }

      // Utilidades para robustecer la petición ante fallos transitorios
      const REQUEST_CONFIG = {
        timeoutMs: 12000,
        maxRetries: 1,
        initialRetryDelayMs: 800
      };

      function wait(ms) {
        return new Promise(function(resolve) {
          setTimeout(resolve, ms);
        });
      }

      function fetchWithTimeout(url, options, timeoutMs) {
        const controller = new AbortController();
        const timer = setTimeout(function() {
          controller.abort();
        }, timeoutMs);

        return fetch(url, Object.assign({}, options, { signal: controller.signal }))
          .finally(function() {
            clearTimeout(timer);
          });
      }

      function shouldRetryRequest(error) {
        // Reintentar solo en timeout, error de red o errores 5xx
        return !!(error && (error.isTimeout || error.isNetworkError || error.isServerError));
      }

      function submitConsultRequest(payload) {
        return fetchWithTimeout('https://uripgq2aeot32wojigzatop5wu0zvewq.lambda-url.us-east-2.on.aws/api/consultar-servicio', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }, REQUEST_CONFIG.timeoutMs)
          .then(function(response) {
            if (response.status >= 500) {
              const serverError = new Error('Error temporal del servidor. Status: ' + response.status);
              serverError.isServerError = true;
              throw serverError;
            }

            if (response.status !== 200) {
              throw new Error('Error en la respuesta del servidor. Status: ' + response.status);
            }

            return response.json().then(function(data) {
              if (data && data.success === true) {
                return data;
              }

              const errorMensaje = data && data.mensaje ? data.mensaje : 'No se pudo procesar tu solicitud.';
              throw new Error(errorMensaje);
            });
          })
          .catch(function(error) {
            if (error && error.name === 'AbortError') {
              const timeoutError = new Error('La solicitud tardó demasiado tiempo.');
              timeoutError.isTimeout = true;
              throw timeoutError;
            }

            // TypeError en fetch normalmente representa fallo de red/CORS/transitorio
            if (error instanceof TypeError) {
              const networkError = new Error('Error de conexión temporal.');
              networkError.isNetworkError = true;
              throw networkError;
            }

            throw error;
          });
      }

      function submitConsultRequestWithRetry(payload) {
        let attempt = 0;

        function execute() {
          return submitConsultRequest(payload).catch(function(error) {
            const canRetry = attempt < REQUEST_CONFIG.maxRetries && shouldRetryRequest(error);
            if (!canRetry) {
              throw error;
            }

            attempt += 1;
            const retryDelay = REQUEST_CONFIG.initialRetryDelayMs * attempt;
            return wait(retryDelay).then(execute);
          });
        }

        return execute();
      }

      // Manejar el envío del formulario
      if (callForm) {
        callForm.addEventListener('submit', function(e) {
          e.stopPropagation();
          e.preventDefault();
          
          const nameInput = document.getElementById('moxie-call-name');
          const phoneInput = document.getElementById('moxie-call-phone');
          const submitButton = document.getElementById('moxie-form-submit');
          
          if (nameInput && phoneInput) {
            const name = nameInput.value.trim();
            const phone = phoneInput.value.trim();
            
            // Validar campos
            if (!name) {
              showErrorMessage('{{ error_title }}', 'Por favor ingresa tu nombre completo.');
              nameInput.focus();
              return;
            }

            if (!phone) {
              showErrorMessage('{{ error_title }}', 'Por favor ingresa tu número de teléfono.');
              phoneInput.focus();
              return;
            }

            // Validar formato del teléfono
            if (!validatePhone(phone)) {
              showErrorMessage('{{ error_title }}', 'Por favor ingresa un número de teléfono válido de 10 dígitos (ejemplo: 3001234567).');
              phoneInput.focus();
              return;
            }

            const cleanPhone = phone.replace(/\D/g, '');

            // Mostrar estado de carga visible mientras se envía
            if (submitButton) {
              const originalText = submitButton.textContent;
              setFormLoadingState(true, submitButton, originalText);
              
              submitConsultRequestWithRetry({
                nombre: name,
                telefono: cleanPhone
              })
              .then(function() {
                const successMessage = MOXIE_TEXTS.successMessage + ' Te llamaremos pronto al ' + cleanPhone + '.';
                let successTitle = MOXIE_TEXTS.successTitle;
                if (successTitle.includes('{{name}}')) {
                  successTitle = successTitle.replace(/\{\{name\}\}/g, name);
                } else {
                  successTitle = '¡Gracias ' + name + '!';
                }
                showSuccessMessage(successTitle, successMessage);

                // Cerrar el popup después de 3 segundos
                setTimeout(function() {
                  showInitialView();
                  closePopup();
                }, 3000);
              })
              .catch(function(error) {
                console.error('Error al enviar formulario:', error);
                const genericMessage = 'Hubo un error al enviar tus datos. Por favor intenta de nuevo más tarde.';
                const errorMessage = error && error.message ? error.message : genericMessage;
                showErrorMessage(MOXIE_TEXTS.errorTitle, errorMessage);
              })
              .finally(function() {
                // Restaurar botón
                setFormLoadingState(false, submitButton, originalText);
              });
            }
          }
        });
      }

      // Validar teléfono mientras el usuario escribe (solo números)
      const phoneInput = document.getElementById('moxie-call-phone');
      if (phoneInput) {
        phoneInput.addEventListener('input', function(e) {
          // Solo permitir números
          this.value = this.value.replace(/\D/g, '');
          
          // Limitar a 10 dígitos
          if (this.value.length > 10) {
            this.value = this.value.slice(0, 10);
          }
        });

        // Validar al perder el foco
        phoneInput.addEventListener('blur', function(e) {
          const value = this.value.replace(/\D/g, '');
          if (value && value.length !== 10) {
            this.style.borderColor = '#e74c3c';
          } else {
            this.style.borderColor = '';
          }
        });
      }
    }

    // Múltiples estrategias para asegurar la ejecución
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initFloatingButton, 50);
      });
    } else {
      // DOM ya está listo
      setTimeout(initFloatingButton, 50);
    }

    // También intentar después de que la ventana esté completamente cargada
    window.addEventListener('load', function() {
      setTimeout(initFloatingButton, 100);
    });

    // Último intento después de un delay más largo
    setTimeout(initFloatingButton, 500);
  })();
